import { render, staticRenderFns } from "./UpdateBox1.vue?vue&type=template&id=565f68ae"
import script from "./UpdateBox1.vue?vue&type=script&lang=js"
export * from "./UpdateBox1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports